<template>
<div class='testPage'>
      <Row class="answerBox">
        <Col span="24" style="padding: 10px">
          <div class="testBox">
            <Col span="24" style="text-align: right"><span class="el-icon-time">倒计时：{{ count }}s</span></Col>
            <div>{{current+1}}.{{ testInfo.topic }}（{{testInfo.type == 1?'单选题':'多选题'}}）</div>
            <RadioGroup v-model="radioAnswer" style="padding: 10px 0" vertical v-if="testInfo.type == 1">
              <Radio label="a">
                <span>A.{{ testInfo.optionA }}</span>
              </Radio>
              <Radio label="b">
                <span>B.{{ testInfo.optionB }}</span>
              </Radio>
              <Radio label="c" v-if="testInfo.optionC">
                <span>C.{{ testInfo.optionC }}</span>
              </Radio>
              <Radio label="d" v-if="testInfo.optionD">
                <span>D.{{ testInfo.optionD }}</span>
              </Radio>
              <Radio label="e" v-if="testInfo.optionE">
                <span>E.{{ testInfo.optionE }}</span>
              </Radio>
              <Radio label="f" v-if="testInfo.optionF">
                <span>F.{{ testInfo.optionF }}</span>
              </Radio>
            </RadioGroup>

            <CheckboxGroup
              v-model="checkAnswer"
              style="display: flex; flex-direction: column; padding: 10px 0"
              v-if="testInfo.type == 2"
            >
              <Checkbox label="a">
                <span>A.{{ testInfo.optionA }}</span>
              </Checkbox>
              <Checkbox label="b">
                <span>B.{{ testInfo.optionB }}</span>
              </Checkbox>
              <Checkbox label="c" v-if="testInfo.optionC">
                <span>C.{{ testInfo.optionC }}</span>
              </Checkbox>
              <Checkbox label="d" v-if="testInfo.optionD">
                <span>D.{{ testInfo.optionD }}</span>
              </Checkbox>
              <Checkbox label="e" v-if="testInfo.optionE">
                <span>E.{{ testInfo.optionE }}</span>
              </Checkbox>
              <Checkbox label="f" v-if="testInfo.optionF">
                <span>F.{{ testInfo.optionF }}</span>
              </Checkbox>
            </CheckboxGroup>
          </div>
        </Col>
      </Row>

      <Divider/>

      <div class="footer">
        <Button type="primary" @click="handIn">交卷</Button>
        <div style="display:flex;align-items:center">
          {{current+1}} / {{testList.length}}
          <Button @click="nextQuestion" style="margin-left:.5vw" v-if="testList.length > current+1"> 下一题</Button>
        </div>
        
      </div>

      <Modal
        v-model="showAnswer"
        class="hisdange"
        @on-cancel="showAnswer = false"
        title="确认交卷"
      >
      <Row>
        <Col span="24" class="info_box">
        <p>到目前为止您的答题情况如下</p> 
        <p>
          单选题 
          总数：<span>{{answerInfo.radioCount}}</span>
          已答：<span style="color:green">{{answerInfo.radioAnswer}}</span>
          未答：<span style="color:orange">{{answerInfo.radioCount-answerInfo.radioAnswer}}</span>
        </p>
        <p>
          多选题 
          总数：<span>{{answerInfo.multipleCount}}</span>
          已答：<span style="color:green">{{answerInfo.multipleAnswer}}</span>
          未答：<span style="color:orange">{{answerInfo.multipleCount-answerInfo.multipleAnswer}}</span>
        </p>
        <p>是否确认交卷</p>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="primary" size="small" @click="submitAnswer">确定</Button>
        <Button size="small" @click="showAnswer = false">取消</Button>
      </div>
    </Modal>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  testId:'',//套题id
  testList:[],//全部试题
  testInfo: [], //答题信息
  radioAnswer: "", //单选答案
  checkAnswer: [], //多选答案
  showAnswer:false,//确认交卷弹窗
  current:0,//初始页面 从0开始
  answerArr:[],//全部答案数组
  answerInfo:{},//答题信息
  isSubmit:false,//离开页面前是否提交过答题
  resultInfo:{},//交卷结果
  count: "",
};
},
activated(){
  this.count = this.$route.query.count
  this.testId = this.$route.query.testId

  this.getExam()
},
 beforeRouteLeave(to, form, next) {
   if(!this.isSubmit){
    this.showAnswer = false
    this.$axios
    .post("/safe-train/exam/confirmSubmit",{
      collectionId: this.testId,
      option: this.testList[this.current].theAnswer?this.testList[this.current].theAnswer:"",
      questionId: this.testList[this.current].id
    })
    .then((res) => {
      if (res.code == 1) {
        this.$Message.success('已自动交卷')
      } else {
        this.$Message.error(res.msg);
      }
    });
    clearInterval(this.timer);
    next()
   } else {
     clearInterval(this.timer);
      //  this.$router.push({name:'TestAnswerResult',query:{testInfo: JSON.stringify(this.resultInfo)}})
      this.$Message.success('已交卷')
     next()
   }
  },
//方法集合
methods: {
  //获取试题
  getExam(){
    this.testInfo = {}
    this.$axios
    .get("/safe-train/exam/startExam?id=" + this.testId)
    .then((res) => {
      if (res.code == 1) {
        this.testList = res.data;
        this.testInfo = res.data[this.current]
        if(this.current == 0){
          this.setTime();
        }
      } else {
        this.$Message.error(res.msg);
      }
    });
  },
  //下一题
  nextQuestion(val){
    if(this.testInfo.type == 1){
      this.testList[this.current].theAnswer = this.radioAnswer? this.radioAnswer:""
    } else {
      this.testList[this.current].theAnswer = String(this.checkAnswer)?String(this.checkAnswer):""
    }

    if(!this.testList[this.current].theAnswer){
      this.$Message.warning('请选择答案')
      return false;
    }
    console.log(this.answerArr,'arr',this.testList)

    // 下一题
    this.$axios
    .post("/safe-train/exam/nextQuestion",{
      collectionId: this.testId,
      option: this.testList[this.current].theAnswer,
      questionId: this.testList[this.current].id
    })
    .then((res) => {
      if (res.code == 1) {
        // 交卷时请求下一题暂存答案
        if(val && val == 2){
          this.getResult();
          return false
        }

        //非交卷行为
        this.testInfo = {};
        this.radioAnswer = "";
        this.checkAnswer = [];
        this.current += 1;
        this.getExam()
        // this.testInfo = this.testList[this.current];
      } else {
        this.$Message.error(res.msg);
      }
    });
  },
  //交卷
  handIn(){
    // for(var i in this.testList){
    //   var item = this.testList[i]
    //     if(!item.theAnswer){
    //       this.$Message.warning('有题目未完成')
    //       return false
    //     }
    // }
    // if(this.testInfo.type == 1){
    //   this.testList[this.current].theAnswer = this.radioAnswer? this.radioAnswer:""
    // } else {
    //   this.testList[this.current].theAnswer = String(this.checkAnswer)?String(this.checkAnswer):""
    // }
    // if(!this.testList[this.current].theAnswer){
    //   this.$Message.warning('当前题目未完成')
    //   return
    // }
    this.nextQuestion(2);
  },
  //获取交卷后的答题数据
  getResult(){
    this.$axios
    .get("/safe-train/exam/submit?id=" + this.testId)
    .then((res) => {
      if (res.code == 1) {
        this.answerInfo = res.data
        this.showAnswer = true
      } else {
        this.$Message.error(res.msg);
      }
    });
  },
  //提交考试结果
  submitAnswer(){
    this.showAnswer = false
    this.$axios
    .post("/safe-train/exam/confirmSubmit",{
      collectionId: this.testId,
      option: this.testList[this.current].theAnswer?this.testList[this.current].theAnswer:"",
      questionId: this.testList[this.current].id
    })
    .then((res) => {
      if (res.code == 1) {
        this.isSubmit = true;
        this.resultInfo = res.data;
        this.$router.replace({name:'TestAnswerResult',query:{testInfo: JSON.stringify(res.data)}})
      } else {
        this.$Message.error(res.msg);
      }
    });
  },
  //倒计时
  setTime() {
      const TIME_COUNT = this.count*60;
      this.count = TIME_COUNT;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
          } else {
          this.submitAnswer()
          clearInterval(this.timer);
          this.timer = null;
          }
        }, 1000)
    },
},
}
</script>
<style lang='less' scoped>
.testPage{
  height: 100%;
  padding: 1vw;
  .answerBox{
    height: 80vh;
    overflow: auto;
    padding: 2vw 10vw;
    .testBox{
      background: #f5f5f5;
      padding: 1vw;
      border-radius: .4vw;
    }
  }
  .footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.info_box{
  p{
    font-size: .8vw;
    padding: .2vw;
    span{
      font-size: 1vw;
    }
  }
}
</style>